import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bd34956"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"appointment_title\" data-v-5bd34956><span class=\"appointment_title_text\" data-v-5bd34956>以下の内容で予約しています</span></h1><p class=\"appointment_text\" data-v-5bd34956><span class=\"appointment_text_clause\" data-v-5bd34956>このページからの日程の変更は、</span><br data-v-5bd34956><span class=\"appointment_text_clause\" data-v-5bd34956>面談日が平日の場合、当日の9時（土日の場合は当日の8時）</span><br data-v-5bd34956><span class=\"appointment_text_clause\" data-v-5bd34956>まで可能です</span></p><p class=\"appointment_text\" data-v-5bd34956><span class=\"appointment_text_clause\" data-v-5bd34956>締切時間以降に変更を希望される場合は、</span><span class=\"appointment_text_clause\" data-v-5bd34956>メールでご連絡ください</span></p><a class=\"text_link\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-5bd34956>webmaster@massmedian.co.jp</a>", 4)
const _hoisted_6 = { class: "appointment_layout_confirm" }
const _hoisted_7 = { class: "appointment_confirm_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談場所", -1))
const _hoisted_9 = { class: "appointment_confirm_item_value" }
const _hoisted_10 = { class: "appointment_confirm_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談日", -1))
const _hoisted_12 = { class: "appointment_confirm_item_value" }
const _hoisted_13 = { class: "appointment_confirm_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談時間", -1))
const _hoisted_15 = { class: "appointment_confirm_item_value" }
const _hoisted_16 = { class: "appointment_confirm_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appointment_confirm_item_title" }, "面談形態", -1))
const _hoisted_18 = { class: "appointment_confirm_item_value" }
const _hoisted_19 = { class: "appointment_button" }
const _hoisted_20 = { class: "appointment_button_prev" }
const _hoisted_21 = { class: "appointment_button_next" }
const _hoisted_22 = {
  key: 0,
  class: "appointment_cancel"
}

import { ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { useRouter } from 'vue-router';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentchangeView',
  setup(__props) {

const isLoading = ref(false);
const router = useRouter();

const areaName = computed(() => store.getters['appointment/areaName']);
const interviewDateDisplay = computed(() => store.getters['appointment/interviewDateDisplay']);
const interviewTimeDisplay = computed(() => store.getters['appointment/interviewTimeDisplay']);
const mainRegTypeName = computed(() => store.getters['appointment/mainRegTypeName']);
const changeInterviewFlg = computed(() => store.getters['appointment/changeInterviewFlg']);

const getInfo = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('appointment/getInterviewInfo');
    isLoading.value = false;
  } catch (e) {
    store.dispatch('toasts/appendTimeToast', { label: '面談予約の取得に失敗しました', duration: null });
    isLoading.value = false;
  }
};

const transitionPage = async () => {
  store.commit('appointment/init');
  router.push({ name: 'd00' });
};

const transitionPreviousPage = () => {
  router.push({ name: 'f00' });
};

getInfo();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(areaName)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(interviewDateDisplay)), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(interviewTimeDisplay)), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(mainRegTypeName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseButton, {
            theme: "tertiary",
            onClick: transitionPreviousPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseButton, {
            theme: "primary",
            disabled: !_unref(changeInterviewFlg),
            onClick: transitionPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("日程を変更する")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      (_unref(changeInterviewFlg))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_router_link, {
              class: "appointment_cancel_link",
              to: { name: 'd11' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("面談をキャンセル")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})